import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AppliedToplineItem, FieldStatus } from 'generated/graphql';

import { ToplineAddClickedEvent } from '../ToplineAddClickedEvent';

@Component({
  selector: 'app-topline-phone',
  templateUrl: './topline-phone.component.html',
  // styleUrls: ['./topline-address.component.scss']
})
export class ToplinePhoneComponent  {
  @Input() topline: Partial<AppliedToplineItem> | any;
  @Input() targetId: string;
  @Input() targetType: 'Entity' | 'EntityConnection';

  /** Will be used for top topline */
  @Input() truncate: boolean;
  @Output() addClick = new EventEmitter<ToplineAddClickedEvent>();

  constructor() { }


  onAddClicked() {
    const eventData = { targetType: this.targetType, targetId: this.targetId, topline: this.topline };
    this.addClick.emit(eventData);
  }

  isDoNotContact() {
    return this.topline?.appliedToplineValue?.status === FieldStatus.DoNotContact;
  }

  isBad() {
    return this.topline?.appliedToplineValue?.status === FieldStatus.Bad;
  }
}
